import { RefundMessage } from 'components/Dialogue';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';
import { memo } from 'react';

export const RefundMsg = memo((props: BaseMsgProps) => {
  const { msg } = props;
  const {
    raw: { refundContent },
  } = msg;

  return refundContent ? (
    <MessageExtendComplex {...props} content={<RefundMessage content={refundContent} />} />
  ) : null;
});
